import { AssetCategory } from "./AssetCategory";

export interface AssetCategoryType {
	id: number;
	name: string;
	displayName: string;
	category: AssetCategory;
	supportedTypes: AssetDataType[];
}

export enum AssetDataType {
	EditableText = "EditableText",
	Link = "Link",
	File = "File",
}

export const AssetCategoryTypes: AssetCategoryType[] = [
    { id: 1, displayName: "Sermon Outline", name: 'Outline', category: AssetCategory.Outline, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 2, displayName: "Sermon Manuscript", name: 'Manuscript', category: AssetCategory.Manuscript, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 3, displayName: "Handout", name: 'Handout', category: AssetCategory.Handout, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 4, displayName: "Devotional", name: 'Devotional', category: AssetCategory.Devotional, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 5, displayName: "Small Group Study", name: 'Small Group Study', category: AssetCategory.SmallGroupStudy, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 6, displayName: "Presentation Slides", name: 'Sermon Slides', category: AssetCategory.SermonSlides, supportedTypes: [AssetDataType.File, AssetDataType.Link] },
    { id: 7, displayName: "Notes", name: 'Notes', category: AssetCategory.Notes, supportedTypes: [AssetDataType.EditableText, AssetDataType.File, AssetDataType.Link] },
    { id: 8, displayName: "Sermon Audio", name: 'Audio', category: AssetCategory.Audio, supportedTypes: [AssetDataType.File, AssetDataType.Link] },
    { id: 9, displayName: "Sermon Video", name: 'Video', category: AssetCategory.Video, supportedTypes: [AssetDataType.File, AssetDataType.Link] },
];
